import { FiX } from 'react-icons/fi';
import { useState } from 'react';
import { useSession } from '@/hooks/useSession';
import { DuelsAccept } from '../duels-accept';
import { Loader } from '@/components/custom/loader';
import { Badge } from '@/components/ui/badge';
import { DuelRequest, DuelRequestAvatar, DuelRequestCard, DuelRequestHeader, DuelRequestPlayers, DuelRequestStar, DuelRequestTabs, DuelRequestTabsItem, DuelRequestTitle } from '@/components/custom/duel';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Dialog } from '@/components/ui/dialog';

export function Requests({ type, data, setActiveTab, activeTab, updateDuelsAndRequests, loadingReceived, loadingSent }) {
  const { session } = useSession(false);
  const [acceptModal, setAcceptModal] = useState(false);
  const [selectedDuel, setSelectedDuel] = useState();

  const userAvatar = session.user.image.url;

  const getBadgeColor = duel => {
    if (type === 'sent' && duel?.status === 'awaiting_acceptance') return 'default';
    if (type === 'received') {
      if (activeTab === 'active') {
        const timeRemaining = calculateTimeRemaining(duel?.['expiration-date']);
        if (timeRemaining < 3) {
          return 'danger';
        } else {
          return 'warning';
        }
      }
    }
  };

  const getDuelStatus = duel => {
    if (type === 'received') {
      if (activeTab === 'refused') return 'Recusado';
      if (activeTab === 'expired') return 'Expirado';
      return `Expira em ${calculateTimeRemaining(duel?.['expiration-date'])}h`;
    }
    if (duel?.status === 'awaiting_acceptance' && type === 'sent') {
      return 'Aguardando';
    }

    switch (duel?.status) {
      case 'expired':
        return 'Expirado';
      case 'refused':
        return 'Recusado';
    }
  };

  function calculateTimeRemaining(expiration) {
    const now = new Date();
    const expirationTime = new Date(expiration);

    const differenceInMs = expirationTime - now;

    const hours = Math.floor((differenceInMs / (1000 * 60 * 60)) % 24);

    if (hours > 0) {
      return hours;
    }
  }

  const handleAcceptModal = duel => {
    if (type === 'received' && activeTab === 'active') {
      setSelectedDuel(duel);
      setAcceptModal(true);
    }
  };

  return (
    <DuelRequest isReceived={type === 'received'}>
      <DuelRequestHeader>
        <DuelRequestTitle>Solicitações {type === 'received' ? 'recebidas' : 'enviadas'}</DuelRequestTitle>

        {type === 'received' && (
          <Badge
            variant="bright"
            size="sm"
          >
            {data.length} {data.length > 1 ? 'novas' : 'nova'}
          </Badge>
        )}
      </DuelRequestHeader>

      {type === 'received' && (
        <DuelRequestTabs>
          <DuelRequestTabsItem
            isActive={activeTab === 'active'}
            onClick={() => setActiveTab('active')}
          >
            Ativos
          </DuelRequestTabsItem>
          <DuelRequestTabsItem
            isActive={activeTab === 'refused'}
            onClick={() => setActiveTab('refused')}
          >
            Recusados
          </DuelRequestTabsItem>
          <DuelRequestTabsItem
            isActive={activeTab === 'expired'}
            onClick={() => setActiveTab('expired')}
          >
            Expirados
          </DuelRequestTabsItem>
        </DuelRequestTabs>
      )}

      {(loadingReceived || loadingSent) && <Loader />}

      {((type === 'received' && !loadingReceived) || (type === 'sent' && !loadingSent)) &&
        data.length > 0 &&
        data.map(item => {
          const opponentAvatar = item?.opponent?.image?.url;

          return (
            <DuelRequestCard
              key={item.id}
              isClickable={type === 'received' && activeTab === 'active'}
              onClick={() => handleAcceptModal(item)}
            >
              <DuelRequestPlayers>
                <DuelRequestAvatar>
                  <AvatarWrapper
                    size="sm"
                    src={item?.['creator-id'] === session?.user?.id ? userAvatar : opponentAvatar}
                    text={session?.user?.name}
                  />
                  <DuelRequestStar />
                </DuelRequestAvatar>

                <FiX className="text-danger" />

                <DuelRequestAvatar>
                  <AvatarWrapper
                    size="sm"
                    src={item?.opponent?.id === session?.user?.id ? userAvatar : opponentAvatar}
                    text={item?.opponent?.name}
                  />
                </DuelRequestAvatar>
              </DuelRequestPlayers>

              <Badge
                variant={getBadgeColor(item)}
                size="sm"
              >
                {getDuelStatus(item)}
              </Badge>
            </DuelRequestCard>
          );
        })}
      {type === 'received' && data.length <= 0 && !loadingReceived && <p className="mb-0">Não há solicitações com este status</p>}
      {type === 'sent' && data.length <= 0 && !loadingSent && <p className="mb-0">Nenhuma solicitação enviada</p>}

      <Dialog
        open={acceptModal}
        onOpenChange={setAcceptModal}
      >
        <DuelsAccept
          open={acceptModal}
          setOpen={setAcceptModal}
          duel={selectedDuel}
          updateDuelsAndRequests={updateDuelsAndRequests}
        />
      </Dialog>
    </DuelRequest>
  );
}
